import React from 'react';
import './HotspotYesNo.css';

function HotspotYesNo({ pregunta, opcionesPorDropdown, respuestas, onSelectDropdown, disabled, showCorrectAnswer = false, respuestaCorrecta = null }) {
  // Obtener respuesta actual para esta pregunta
  const respuestaHotspot = respuestas[pregunta.id] || {};
  
  // Ordenar dropdowns por ID
  const dropdownIds = Object.keys(opcionesPorDropdown)
    .map(id => parseInt(id))
    .sort((a, b) => a - b);

  const handleRadioChange = (dropdownId, opcionId) => {
    if (!disabled) {
      onSelectDropdown(pregunta.id, dropdownId, opcionId);
    }
  };

  return (
    <div className="hotspot-yesno-container">
      <div className="hotspot-yesno-header">
        <h3 className="answer-area-title">Answer Area</h3>
      </div>
      
      <div className="hotspot-yesno-table">
        <div className="hotspot-yesno-table-header">
          <div className="statements-column-header">Statements</div>
          <div className="yes-column-header">Yes</div>
          <div className="no-column-header">No</div>
        </div>
        
        <div className="hotspot-yesno-table-body">
          {dropdownIds.map((dropdownId) => {
            const opciones = opcionesPorDropdown[dropdownId].sort((a, b) => a.orden - b.orden);
            const enunciado = pregunta.dropdowns_enunciados && pregunta.dropdowns_enunciados[dropdownId]
              ? pregunta.dropdowns_enunciados[dropdownId]
              : `Statement ${dropdownId}`;
            
            // Obtener la opción seleccionada para este dropdown
            const opcionSeleccionadaId = respuestaHotspot[`dropdown_${dropdownId}`] || null;
            
            // Separar opciones Yes y No
            const opcionYes = opciones.find(op => op.texto.toLowerCase() === 'yes' || op.texto === 'Sí');
            const opcionNo = opciones.find(op => op.texto.toLowerCase() === 'no' || op.texto === 'No');
            
            // Obtener respuesta correcta si está disponible
            const correctaId = showCorrectAnswer && respuestaCorrecta ? respuestaCorrecta[`dropdown_${dropdownId}`] : null;
            const opcionCorrecta = correctaId != null ? opciones.find((o) => o.id === correctaId) : null;
            const esCorrecto = correctaId != null && opcionSeleccionadaId === correctaId;
            const esIncorrecto = showCorrectAnswer && correctaId != null && opcionSeleccionadaId != null && opcionSeleccionadaId !== correctaId;
            const rowFeedbackClass = showCorrectAnswer && correctaId != null
              ? esCorrecto
                ? ' hotspot-yesno-row-correct'
                : esIncorrecto
                ? ' hotspot-yesno-row-incorrect'
                : ' hotspot-yesno-row-sin-responder'
              : '';
            
            return (
              <React.Fragment key={dropdownId}>
                <div className={`hotspot-yesno-row${rowFeedbackClass}`}>
                  <div className="statement-cell">
                    {enunciado}
                  </div>
                  <div className="yes-cell">
                    <label className="radio-label">
                      <input
                        type="radio"
                        name={`hotspot_${pregunta.id}_${dropdownId}`}
                        value={opcionYes?.id || ''}
                        checked={opcionSeleccionadaId === opcionYes?.id}
                        onChange={() => !showCorrectAnswer && opcionYes && handleRadioChange(dropdownId, opcionYes.id)}
                        disabled={disabled || showCorrectAnswer || !opcionYes}
                        className="yesno-radio"
                      />
                      <span className="radio-custom"></span>
                    </label>
                    {showCorrectAnswer && opcionCorrecta && opcionCorrecta.id === opcionYes?.id && (
                      <span className="hotspot-yesno-feedback-check">✓</span>
                    )}
                    {showCorrectAnswer && esIncorrecto && opcionSeleccionadaId === opcionYes?.id && (
                      <span className="hotspot-yesno-feedback-cross">✗</span>
                    )}
                  </div>
                  <div className="no-cell">
                    <label className="radio-label">
                      <input
                        type="radio"
                        name={`hotspot_${pregunta.id}_${dropdownId}`}
                        value={opcionNo?.id || ''}
                        checked={opcionSeleccionadaId === opcionNo?.id}
                        onChange={() => !showCorrectAnswer && opcionNo && handleRadioChange(dropdownId, opcionNo.id)}
                        disabled={disabled || showCorrectAnswer || !opcionNo}
                        className="yesno-radio"
                      />
                      <span className="radio-custom"></span>
                    </label>
                    {showCorrectAnswer && opcionCorrecta && opcionCorrecta.id === opcionNo?.id && (
                      <span className="hotspot-yesno-feedback-check">✓</span>
                    )}
                    {showCorrectAnswer && esIncorrecto && opcionSeleccionadaId === opcionNo?.id && (
                      <span className="hotspot-yesno-feedback-cross">✗</span>
                    )}
                  </div>
                </div>
                {showCorrectAnswer && opcionCorrecta && (
                  <div className="hotspot-yesno-feedback-row">
                    <div className="hotspot-yesno-feedback-cell">
                      <span className="hotspot-yesno-correct-answer-text">
                        Correct: <strong>{opcionCorrecta.texto}</strong>
                      </span>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default HotspotYesNo;






